module.exports = "<div class=\"container\">\r\n  <div class=\"content\">\r\n    <div class=\"flex flex-row\">\r\n      <h1 appHeadline class=\"logo\">Palettes</h1>\r\n      <div class=\"flex flex-grow\"></div>\r\n      <div class=\"flex flex-column content-box\">\r\n        <span>&copy; 2017 PixelSnake</span>\r\n        <a href=\"http://pxsnake.de/about\">Imprint</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/ui/footer/footer.component.html
// module id = ../../../../../src/app/ui/footer/footer.component.html
// module chunks = main